<template>
  <div class="card">
    <a class="alp" href="">
      <div class="thumb"><img src="/img/dummy2.jpg" alt=""></div>
      <div class="desc">
        <p class="ttl txt-overflow">タイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトルタイトル</p>
        <p class="txt txt-overflow">説明文が入ります説明文が入ります説明文が入ります説明文が入ります。説明文が入ります説明文が入ります説明文が入ります説明文が入ります。</p>
        <div class="info"><span class="data1">締切：2018年0月00日（○）</span><span class="data2">必着</span></div>
      </div>
    </a>
  </div>
</template>

<style scoped lang="scss">
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
$fontcolor: #333;

.card {
  margin-top: 2.5%;
  width: 31.633%;
  background: #fff;
  a {
    display: block;
  }
  img {
    width: 100%;
  }
  .desc {
    padding: 25px 20px 0;
    background: #fff;
    .ttl {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.8;
      color: $fontcolor;
      height: 3.6em;
    }
    .txt {
      margin: 20px 0;
      font-size: 12px;
      font-weight: bold;
      line-height: 1.8;
      color: $fontcolor;
      height: 3.6em;
      box-sizing: content-box;
    }
    .info {
      border-top: 1px solid #ddd;
      padding: 16px 0;
      line-height: 1;
      font-size: 10px;
      font-weight: 500;
      color: $fontcolor;
      span.data2 {
        float: right;
      }
    }
  }
  @media only screen and (max-width: 750px) {
    margin-top: 6% !important;
    width: 100%;
  }
}
</style>

<script>
export default {
  name: "card"
};
</script>
